import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({ dispatch }, payload) => {
    return serves.folharevento1270.cadastra(payload).then(res => {
        dispatch('ActionSetMsg', res)
    }).catch(err => {
        dispatch('ActionSetMsg', err)
    })
}
export const ActionLista = ({ dispatch }, payload) => {
    return serves.folharevento1270.lista(payload).then(res => {
        dispatch('ActionSetLista', res)
    }).catch(err => {
        dispatch('ActionSetLista', err)
    })
}
export const ActionPesquisa = ({ dispatch }, payload) => {
    return serves.folharevento1270.lista(payload).then(res => {
        dispatch('ActionSetBoletins', res)
    }).catch(err => {
        dispatch('ActionSetBoletins', res)
    })
}

export const ActionDeletar = ({ dispatch }, payload) => {
    return serves.folharevento1270.delete(payload).then(res => {
        console.log(res);
        dispatch('ActionSetMsg', res)
    }).catch(err => {
        dispatch('ActionSetMsg', err)
    })
}
export const ActionEditar = ({ dispatch }, payload) => {
    return serves.folharevento1270.editar(payload).then(res => {
        dispatch('ActionSetEditar', res)
    }).catch(err => {
        dispatch('ActionSetEditar', err)
    })
}
export const ActionUpdate = ({ dispatch }, payload) => {
    return serves.folharevento1270.update(payload).then(res => {
        dispatch('ActionSetMsg', res)
    }).catch(err => {
        dispatch('ActionSetMsg', err)
    })
}
export const ActionEventoUpdate = ({ dispatch }, payload) => {

    return serves.folharevento1270.update1270(payload).then(res => {
        dispatch('ActionSetMsg', res)
    }).catch(err => {
        dispatch('ActionSetMsg', err)
    })
}

export const ActionEventoDeletar = ({ dispatch }, payload) => {
    return serves.folharevento1270.delete1270(payload).then(res => {
        dispatch('ActionSetMsg', res)
    }).catch(err => {
        dispatch('ActionSetMsg', res)
    })
}
export const ActionSetLista = ({ commit }, payload) => {
    commit(types.SET_LISTA, payload)
}
export const ActionSetMsg = ({ commit }, payload) => {
    commit(types.SET_MSG, payload)
}
export const ActionSetEditar = ({ commit }, payload) => {
    commit(types.SET_EDITAR, payload)
}
export const ActionSetBoletins = ({ commit }, payload) => {
    commit(types.SET_BOLETINS, payload)
}
export const ActionSetInss = ({ commit }, payload) => {
    commit(types.SET_INSS, payload)
}
